import { render, staticRenderFns } from "./PaycheckAltinnLog.vue?vue&type=template&id=371c77f6&scoped=true&"
import script from "./PaycheckAltinnLog.vue?vue&type=script&lang=ts&"
export * from "./PaycheckAltinnLog.vue?vue&type=script&lang=ts&"
import style0 from "./PaycheckAltinnLog.vue?vue&type=style&index=0&id=371c77f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c77f6",
  null
  
)

export default component.exports